module.exports = __webpack_public_path__ + "static/kvm_7.e827d130.jpg";